/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AddPatientResponseIntegrationViewModel {
  /**
   * Patient account number
   */
  accountNumber?: number;
  /**
   * True if patient is incomplete (exists in Demographic Import Errors), false if patient account has been posted
   */
  isHolding?: boolean;
  /**
   * Patient name
   */
  patientName?: string | null;
  /**
   * Indicates whether account was added or updated
   */
  addedUpdated?: string | null;
  /**
   * For holding patients, indicates the fields that are missing or invalid
   */
  fieldIssues?: string | null;
}
